import { AMPLITUDE_OPTIONS } from './amplitude'
import { segment } from './segment'
import { SegmentTransitionFlag, ReportingTransitionAdapter } from '@pathccm/browser-analytics'

export function getReportingAdapter (flag: SegmentTransitionFlag): ReportingTransitionAdapter {
  return new ReportingTransitionAdapter(flag, AMPLITUDE_OPTIONS, segment)
}
